import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import LocaleSelectMini from 'components/global/LocaleSelectMini';
import { FormattedMessage } from 'react-intl';
import {
  PERSONAL_DETAILS,
  INTRODUCTION,
  LOCATION_DETAILS,
  THANK_YOU,
  MATCHING_PREFERENCES,
} from './helpers';

import {
  INTRODUCTION as INTRODUCTION_2,
  PERSONAL_DETAILS as PERSONAL_DETAILS_2,
  LOCATION_DETAILS as LOCATION_DETAILS_2,
  THANK_YOU as THANK_YOU_2,
  MATCHING_PREFERENCES as MATCHING_PREFERENCES_2,
} from '../onboarding_generic/data';

function BottomBar({
  currentStep,
  nextPage = () => {},
  nonFormPage = false,
  previousPage = () => {},
  emailError = undefined,
  skipToEnd,
  specialized = false,
}) {
  // choose which set of steps to use
  const steps = specialized
    ? {
        INTRODUCTION: INTRODUCTION_2,
        PERSONAL_DETAILS: PERSONAL_DETAILS_2,
        LOCATION_DETAILS: LOCATION_DETAILS_2,
        THANK_YOU: THANK_YOU_2,
        MATCHING_PREFERENCES: MATCHING_PREFERENCES_2,
      }
    : {
        INTRODUCTION,
        PERSONAL_DETAILS,
        LOCATION_DETAILS,
        THANK_YOU,
        MATCHING_PREFERENCES,
      };

  return (
    <div className="bottom-bar">
      <LocaleSelectMini />
      <div className="flex-center">
        {currentStep !== steps.THANK_YOU &&
          currentStep !== steps.LOCATION_DETAILS &&
          currentStep !== steps.INTRODUCTION &&
          currentStep !== steps.PERSONAL_DETAILS && (
            <div
              className="small-button"
              onClick={previousPage}
              role="presentation"
            >
              <FormattedMessage defaultMessage="Previous" />
            </div>
          )}
        {skipToEnd && (
          <div
            className="small-button skip-button"
            onClick={skipToEnd}
            role="presentation"
          >
            <FormattedMessage defaultMessage="Skip" />
          </div>
        )}
        {nonFormPage ? (
          <Button
            className={`rounded-button-${
              currentStep === steps.THANK_YOU ? 'blue' : 'teal'
            } next-button`}
            onClick={nextPage}
          >
            {currentStep === steps.THANK_YOU ? (
              <FormattedMessage defaultMessage="Dashboard" />
            ) : (
              <FormattedMessage defaultMessage="Next" />
            )}
          </Button>
        ) : (
          <Button
            className="rounded-button-teal next-button"
            type={emailError ? 'button' : 'submit'}
          >
            {<FormattedMessage defaultMessage="Next" />}
          </Button>
        )}
      </div>
    </div>
  );
}

BottomBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  emailError: PropTypes.string,
  nextPage: PropTypes.func,
  nonFormPage: PropTypes.bool,
  previousPage: PropTypes.func,
  skipToEnd: PropTypes.func,
  specialized: PropTypes.bool,
};

export default BottomBar;
